<template>
	<UserRegistrationLayout showProgressBar class="pin-extension">
		<div class="title-container">Pin the extension</div>
		<img class="pin-img" src="../../assets/img/extension-pin-guide.png" />
		<AnemicButton data-cy="registration-done-pin" class="done-button" @click="goToNextPage">Continue</AnemicButton>
		<div class="skip-extension-container flex-row flex-end--center">
			<div class="skip-extension-text-container" @click="goToNextPage">I don’t want to pin the extension</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import AnalyticsService from '@/utils/AnalyticsService';
import UserRegistrationLayout from './UserRegistrationLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';

import UserRegistrationService from './helpers/UserRegistrationService';

export default {
	name: 'PinExtension',
	components: {
		UserRegistrationLayout,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		...mapGetters(['user']),
	},
	mounted() {
		this.reportEvent();
	},
	methods: {
		...mapActions(['initUser']),
		async reportEvent() {
			await this.initUser({ avoidRedirect: true }); // Try to sign in the user so we can update extension as well. so do not remove this line for better experience for the ext.
			AnalyticsService.sendEvent('Extension Installed', {});
		},
		async goToNextPage() {
			ExtensionCommunicationService.reportPinnedExtension(); // Let the extension know we are done here.

			const { signup_referrer } = this.user?.profile?.metadata || {};
			this.navigateTo({ path: UserRegistrationService.getExtensionFirstPageAfterSignup(signup_referrer, this.$route.query.return_to) });
		},
	},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.pin-extension {
	.pin-img {
		width: 700px;
		height: 244px;
	}
}
.title-container {
	font-size: 24px;
	font-weight: 600;
	margin: 20px 0px 70px 0px;
	background: var(--bg-color);
	color: var(--primary-font-color);
}
.done-button {
	height: 45px;
	width: 180px;
	padding: 0px;
	color: var(--bg-color);
	font-size: 14px !important;
	margin: 100px 0px 20px 0px;
	border: 1px solid var(--bg-color);
	background: var(--bold-border-color) !important;
}
.skip-extension-container {
	width: 100%;
	right: -50px;
	bottom: -20px;
	position: relative;

	.skip-extension-text-container {
		width: 200px;
		font-size: 11px;
		text-align: right;
		text-decoration: underline;
		cursor: pointer !important;
		color: var(--primary-font-color);
	}
}
</style>
